module.exports = __webpack_public_path__ + "static/video1-13b027e612f92025781ec85e55afc62f.jpg";